const doc = [({"da":({"js":({"notifications":({"types":({"team_application_declined":({"your_application_to_team_was_declined":"Din ansøgning til %{team_name} blev afvist."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;